export const PUBLIC_PATH = process.env.PUBLIC_URL;
export const SPARQL_ENDPOINT = process.env.REACT_APP_SPARQL_ENDPOINT;
